export default __webpack_public_path__ + "static/media/1310.98fd2382.png";